// Third Party
import * as React from 'react';
import Image from 'next/image';

// Utils
import { routes } from '@routes';
import { imagekitLoader } from '@utils/imagekit-loader';
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';
import { Props } from '.';

// UI
import { Typography } from '@components/typography';
import { concatenateAndReplace } from '@utils/test-helpers';

export const MobileSection: React.FC<Props> = ({ listings }) => {
  return (
    <div className="md:hidden py-4">
      <div className="">
        <Typography
          component="h5"
          variant="title6"
          variantM="title4"
          className="mb-6"
        >
          Other Properties from this Host
        </Typography>
      </div>

      <div>
        <div className="flex overflow-x-auto space-x-4">
          {listings.slice(1, 20).map((listing, index) => {
            return (
              <a
                key={index}
                href={routes.listings({
                  slug: listing.slug,
                })}
                className="flex-shrink-0 w-80"
              >
                <div className="relative rounded-md shadow-md w-full aspect-[3/2]">
                  <Image
                    layout="fill"
                    src={
                      listing.galleryAssets.length > 0
                        ? listing.galleryAssets[0].url || ''
                        : ''
                    }
                    alt={listing.name || 'listing result'}
                    placeholder="blur"
                    className="object-center object-cover rounded-md shadow-md"
                    loader={imagekitLoader}
                    blurDataURL={GRAY_PIXEL_DATA_URL}
                    sizes="100vw"
                    lazyBoundary="400px"
                    // When there are no PMs listed, the first image is the largest
                    // piece of content on a mobile load, prioritize for LCP optimization
                    priority={index == 0}
                  />
                </div>

                <div>
                  <h4
                    className="text-xs font-semibold leading-tight sm:text-sm mt-2"
                    data-testid={concatenateAndReplace(`${listing.name}`)}
                  >
                    {listing.name}
                  </h4>
                  <div className="text-xs leading-tight mt-0.5 line-clamp-2">
                    {listing.city}, {listing.stateOrProvinceLongName}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};
